<template>
    <div>
        <Head :title="__(title)" />
        <div class="flex flex-wrap">
            <div class="max-w-full lg:w-3/5">
                <form @submit.prevent="update" class="mr-2 overflow-hidden bg-white rounded-md shadow">
                    <div class="flex flex-wrap p-8 -mb-8 -mr-6">
                        <!--Super Admin -->
                        <select-edit-input v-if="auth.user.role.slug !== 'customer'" placeholder="Rechercher un contact" :onInput="doFilter" :items="customers"
                                             v-model="form.contact_id" :error="form.errors.contact_id"
                                             class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Contact')"
                                           :value="ticket?.contact?.first_name ?? ticket?.contact?.phone" :editable="false">
                        </select-edit-input>

                        <select-edit-input placeholder="Rechercher une priorité" :items="priorities"
                                           v-model="form.priority_id" :error="form.errors.priority_id"
                                           class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Priority')"
                                           :value="ticket.priority ?? ''" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input>

                        <select-edit-input v-if="auth.user.role.slug !== 'customer' && !(hidden_fields && hidden_fields.includes('assigned_to'))" placeholder="Rechercher un utilisateur" :onInput="doFilterUsersExceptCustomer" :items="usersExceptCustomers"
                                           v-model="form.assigned_to" :error="form.errors.assigned_to"
                                           class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Assigned to')"
                                           :value="ticket.assigned_user??'Not Assigned'" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input>

                        <select-edit-input placeholder="Selectionner un statut" :items="statuses"
                                           v-model="form.status_id" :error="form.errors.status_id"
                                           class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Status')"
                                           :value="ticket.status?ticket.status.name:'N/A'" :editable="auth.user.role.slug !== 'customer' && user_access.ticket.update && !ticket.closed">
                        </select-edit-input>

                        <select-edit-input v-if="!(hidden_fields && hidden_fields.includes('ticket_type'))" placeholder="Rechercher un type" :items="types"
                                           v-model="form.type_id" :error="form.errors.type_id"
                                           class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Ticket type')"
                                           :value="ticket.type" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input>

                        <select-edit-input v-if="!(hidden_fields && hidden_fields.includes('department'))" @change="getCategories()" placeholder="Rechercher un departement" :items="departments"
                                           v-model="form.department_id" :error="form.errors.department_id"
                                           class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Department')"
                                           :value="ticket.department" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input>

                        <select-edit-input ref="category" v-if="!(hidden_fields && hidden_fields.includes('category'))"  placeholder="Rechercher une categorie" :items="categories"
                                           v-model="form.category_id" :error="form.errors.category_id"
                                           class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Category')"
                                           :value="ticket.category" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input>

                        <!-- <select-edit-input ref="sub_category" v-if="!(hidden_fields && hidden_fields.includes('category')) && form.category_id" placeholder="Rechercher une categoryie" :items="sub_categories"
                                           v-model="form.sub_category_id" :error="form.errors.sub_category_id"
                                           class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Sub Category')"
                                           :value="ticket.sub_category" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input> -->

                        <div class="flex flex-col w-full pb-8 pr-6 assigned_user lg:w-1/3">
                            <div class="mb-1 text-sm font-bold">{{ __('Created') }} </div>
                            <div class="text-sm font-light">{{ moment(ticket.created_at).fromNow() }}</div>
                        </div>

                        <div v-for="entry in entries" class="flex flex-col w-full pb-8 pr-6 assigned_user lg:w-1/3" :key="entry.id">
                            <div class="mb-1 text-sm font-bold">{{ __(entry.label) }} </div>
                            <div class="text-sm font-light">{{ entry.value }}</div>
                        </div>

                        <text-edit-input :editable="user_access.ticket.update && !ticket.closed" v-model="form.subject" :value="ticket.subject" :error="form.errors.subject" class="w-full pb-8 pr-6 lg:w-2/3" :label="__('Objet')" />

                        <div class="flex flex-col w-full pb-8 pr-6 assigned_user lg:w-full">
                            <div class="flex gap-3 w-25">
                                <label class="form-label">{{ __('Description') }}</label>
                                <icon
                                    v-if="!enableEditor && user_access.ticket.update && !ticket.closed && !ticket.audio_url"
                                    name="edit" @click="enableEditor = !enableEditor"
                                    class="w-4 h-4 mr-1 cursor-pointer" />
                            </div>
                            <div v-if="!enableEditor && !ticket.audio_url" class="text-sm font-light"
                                v-html="safeHtml(ticket.details)"></div>
                            <div v-if="enableEditor && !ticket.audio_url"
                                class="flex items-center w-25 ticket_details_area">
                                <ckeditor id="ticketDetails" :editor="editor" v-model="form.details"
                                    :config="editorConfig"></ckeditor>
                                <div class="w-4 h-4 cursor-pointer">
                                    <icon @click="enableEditor = false" name="close"
                                        class="w-4 h-4 ml-2 cursor-pointer" />
                                </div>
                            </div>

                            <div v-if="ticket.audio_url" class="text-sm font-light">
                                <audio controls :src="ticket.audio_url"></audio>
                                <div class="mt-4">
                                    <label class="form-label">{{ __('Transcription') }}</label>

                                    <ckeditor id="ticketDetailsTranscription" :editor="editor"
                                        v-model="form.transcription" :config="editorConfig"></ckeditor>
                                    <div class="w-4 h-4 cursor-pointer">
                                        <icon @click="enableEditor = false" name="close"
                                            class="w-4 h-4 ml-2 cursor-pointer" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-col w-full pb-8 pr-6 assigned_user lg:w-full">
                            <div class="flex gap-3 w-25">
                                <label class="form-label">{{ __('Plan d\'action') }}</label>
                                <icon
                                    v-if="!enableEditPlan && user_access.ticket.update && !ticket.closed"
                                    name="edit" @click="enableEditPlan = !enableEditPlan"
                                    class="w-4 h-4 mr-1 cursor-pointer" />
                            </div>
                            <div v-if="!enableEditPlan" class="text-sm font-light"
                                v-html="safeHtml(ticket.action_plan)"></div>
                            <div v-if="enableEditPlan"
                                class="flex items-center w-25 ticket_details_area">
                                <ckeditor id="ticketaction_plan" :editor="editor" v-model="form.action_plan"
                                    :config="editorConfig"></ckeditor>
                                <div class="w-4 h-4 cursor-pointer">
                                    <icon @click="enableEditPlan = false" name="close"
                                        class="w-4 h-4 ml-2 cursor-pointer" />
                                </div>
                            </div>
                        </div>

                        


                        <!-- Super Admin Comment -->
                        <input ref="file" type="file" accept=".xlsx,.xls,.jpg,.jpeg,.png,.gif,.webp,.doc, .docx,.ppt, .pptx,.txt,.pdf, .zip, .mp3, .mp4, .wav" class="hidden" multiple="multiple" @change="fileInputChange" />
                        <div class="flex-col w-full pb-8 pr-6 lg:w-full">
                            <button type="button" class="flex items-center justify-center pb-3 pl-0 border-0 btn" @click="fileBrowse">
                                <icon name="file" class="flex-shrink-0 h-5 pr-1 fill-gray-400" /> <strong>{{ __('Attach File') }}</strong>
                            </button>
                            <div v-if="fileError()" class="form-error">{{ fileError() }}</div>
                            <div v-if="attachments.length" class="flex items-center justify-between w-full pt-8 pr-6" v-for="(file, fi) in attachments" :key="fi">
                                <div class="flex-1 pr-1">
                                    {{ file.name }} <span class="text-xs text-gray-500">({{ getFileSize(file.size) }})</span> <a v-if="file.user" class="text-sm" :href="this.route('users.edit', file.user.id)">{{ file.user.first_name }} {{ file.user.last_name }}</a> at <span class="text-sm">{{ file.created_at }}</span>
                                </div>
                                <div class="flex items-center justify-end a__buttons ">
                                    <button type="button" class="flex items-center text-blue-500 btn" @click="downloadAttachment(file)">
                                        {{ __('Télécharger') }}</button>
                                    <button v-show="!file.name.includes('complaints')" type="button" class="flex items-center ml-3 text-red-500 btn" @click="removeAttachment(file, fi)">
                                        {{ __('Supprimer') }}</button>
                                </div>
                            </div>
                            <div v-if="form.files.length" class="flex items-center justify-between w-full pt-8 pr-6 lg:w-1/2" v-for="(file, fi) in form.files" :key="fi">
                                <div class="flex-1 pr-1">
                                    {{ file.name }} <span class="text-xs text-gray-500">({{ getFileSize(file.size) }})</span>
                                </div>
                                <button v-if="ticket.status && !ticket.closed" type="button" class="flex items-center justify-center btn" @click="fileRemove(file, fi)">
                                    {{ __('Supprimer') }}</button>
                            </div>
                        </div>

                        <div class="flex items-center w-full pb-8 pr-6 lg:w-1/3" v-if="ticket.status && ticket.closed && ticket.review">
                            <strong>{{ __('Rating') }}: </strong> &nbsp; {{ ticket.review.rating }}
                            <p>
                                {{ ticket.review.review }}
                            </p>
                        </div>

                        <div class="flex flex-col w-full" v-if="ticket.status && ticket.closed && !ticket.review && auth.user.role.slug === 'customer'">
                            <div class="flex flex-col w-full pb-5 assigned_user star__review lg:w-1/3">
                                <div class="font-bold">{{ __('How do you rate this support service?') }} </div>
                                <div class="pt-5 star-rating">
                                    <input type="radio" id="5-stars" name="rating" v-model="form.rating" value="5" />
                                    <label for="5-stars" class="star">&#9733;</label>
                                    <input type="radio" id="4-stars" name="rating" v-model="form.rating" value="4" />
                                    <label for="4-stars" class="star">&#9733;</label>
                                    <input type="radio" id="3-stars" name="rating" v-model="form.rating" value="3" />
                                    <label for="3-stars" class="star">&#9733;</label>
                                    <input type="radio" id="2-stars" name="rating" v-model="form.rating" value="2" />
                                    <label for="2-stars" class="star">&#9733;</label>
                                    <input type="radio" id="1-star" name="rating" v-model="form.rating" value="1" />
                                    <label for="1-star" class="star">&#9733;</label>
                                </div>
                            </div>
                            <textarea-input v-model="form.review" :error="form.errors.review" class="w-full pb-4 pr-6 lg:w-1/3" :label="__('Feedback')" />
                            <div class="flex mb-4 lg:w-1/4"><button class="btn-indigo" type="submit">{{ __('Submit') }}</button></div>
                        </div>
                    </div>
                    <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
                        <button v-if="user_access.ticket.delete" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
                            {{ __('Supprimer') }}</button>
                        <loading-button :loading="form.processing" class="ml-auto btn-indigo" type="submit">{{ __('Save') }}</loading-button>
                    </div>
                </form>
            </div>
            <div class="max-w-full lg:w-2/5">
                <div class="flex flex-col flex-1 ml-2 overflow-hidden bg-white rounded-md shadow chat-area comment-box">
                    <div class="flex-3">
                        <div class="flex flex-col pb-3 chat-header">
                            <h3 class="text-xl">{{ __('Ticket discussion') }}</h3>
                            <p class="text-sm font-light">{{ __('L’historique des commentaires pour ce ticket sera disponible ici..') }}</p>
                            <p class="text-sm font-light">Les commentaires ajoutés seront envoyés par sms ou par appel au plaignant</p>
                        </div>
                    </div>
                    <div class="flex-1 overflow-auto messages reverse__order">
                        <div v-for="(comment, index) in comments.slice().reverse()" :key="index" class="flex mb-4 message">
                            <div v-if="comment.user_id !== user.id" class="flex-2">
                                <div class="relative w-12 h-12">
                                    <span class="w-12 h-12 mx-auto rounded-full user_icon" alt="chat-user" v-if="comment.user">{{ Array.from(comment.user.first_name)[0] }}</span>
                                </div>
                            </div>
                            <div v-if="comment.user_id !== user.id" class="flex-1 px-2 mt__wrap">
                                <h3 class="pt-1 pb-2 text-sm font-bold" v-if="comment.user">{{ comment.user.first_name }} {{ comment.user.last_name }}</h3>
                                <div v-if="comment.type == 'text'" class="inline-block p-2 px-3 leading-5 text-gray-700 bg-gray-300 user-comment-round ckc" v-html="safeHtml(comment.details)"></div>
                                <div v-else class="inline-block p-2 px-3 leading-5 text-white rounded bg-gray-300ckc">
                                    <audio  controls :src="comment.details"></audio>
                                </div>
                                <div class="pl-4"><small class="text-gray-500">{{ moment(comment.updated_at).fromNow(true) }}</small></div>
                            </div>

                            <div v-if="comment.user_id === user.id" class="relative flex w-full">
                                
                                <div  class="flex-1 px-2 text-right mt__wrap">
                                    <div v-if="comment.type == 'text'" class="inline-block p-2 px-3 leading-5 text-white rounded bg-blue ckc" v-html="safeHtml(comment.details)"></div>
                                    <div v-else class="inline-block p-2 px-3 leading-5 text-white rounded bg-blue ckc">
                                        <audio  controls :src="comment.details"></audio>
                                    </div>
                                    <div class="pr-4"><small class="text-gray-500">{{ moment(comment.updated_at).fromNow(true) }}</small></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pt-4 pb-3 flex-2">
                        
                        <div class="flex bg-white rounded-lg shadow write" >
                            <div class="flex-1 ticket_comment_edit" :class="{'hidden animate-pulse':isRecording}">
<!--                                <textarea v-model="comment" name="message" @keydown.enter.exact.prevent="submitComment" class="block w-full px-4 py-4 overflow-hidden text-sm bg-transparent outline-none" rows="1" :placeholder="__('Write a comment and press enter to send...')" autofocus></textarea>-->
                                <ckeditor  id="ticketDiscussion" :editor="editor" v-model="comment" name="comment" :config="editorConfig" autofocus></ckeditor>
                                
                            </div>
                            <div class="flex-1 ticket_comment_edit" :class="{'hidden animate-pulse':!isRecording}">
                                <div class="my-2" v-if="isRecording">Enregistrement en cours ...</div>
                                <div class="flex">
                                    <div class="w-4 h-4 mx-1 rounded-full bg-blue animate-pulse"></div>
                                <div class="w-4 h-4 mx-1 rounded-full bg-blue animate-pulse"></div>
                                <div class="w-4 h-4 mx-1 rounded-full bg-blue animate-pulse"></div>
                                </div>
                            </div>
                            <div class="flex items-center content-center p-2 flex-2 w-35">
                                
                                <div class="flex flex-col space-y-2">
                                    <div class="flex flex-col space-y-1">
                                        <button @click.prevent="startRecording" v-if="!isRecording " class="flex items-center justify-center w-10 h-10 bg-red-500 rounded-full">
                                            <icon class="w-4 h-4 fill-gray-100" name="mic"/>
                                          </button>
                                          <button @click="stopRecording" v-else class="flex items-center justify-center w-10 h-10 bg-gray-500 rounded-full">
                                            <icon class="w-4 h-4 fill-gray-100" name="stop"/>
                                          </button>
                                          <label for="audio-upload" class="flex items-center justify-center w-10 h-10 bg-green-500 rounded-full cursor-pointer">
                                            <icon class="w-4 h-4 fill-gray-100" name="file"/>
                                          </label>
                                    </div>
                                    <input id="audio-upload" type="file" accept="audio/mpeg,audio/wav" class="hidden" @change="handleFileUpload" />
                                    <button @click="submitComment('text')"  :disabled="isRecording || audioFile" class="flex items-center justify-center w-10 h-10 rounded-full bg-blue">
                                      <icon class="w-4 h-4 fill-gray-100" name="send"/>
                                    </button>
                                  </div>
                                
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import safeHtml from "@/Shared/safeHtml";
import { Link, Head } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextEditInput from '@/Shared/TextEditInput'
import SelectInput from '@/Shared/SelectInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import SelectEditInput from '@/Shared/SelectEditInput'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UploadAdapter from '@/Shared/UploadAdapter';
import moment from 'moment'
import axios from 'axios'
import CKEditor from '@ckeditor/ckeditor5-vue';
import { comment } from 'postcss'


export default {
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TextEditInput,
        TextareaInput,
        Link,
        Head,
        Icon,
        SelectInputFilter,
        SelectEditInput,
        ckeditor: CKEditor.component,
    },
    layout: Layout,
    props: {
        title: String,
        ticket: Object,
        priorities: Array,
        statuses: Array,
        types: Array,
        departments: Array,
        categories: {required: false},
        customers: Array,
        usersExceptCustomers: Array,
        attachments: Array,
        comments: Array,
        auth: Object,
        entries: Object,
        hidden_fields: Object,
    },
    remember: false,
    data() {
        return {
            user: this.$page.props.auth.user,
            type_status: [],
            comment: '',
            showMenu: false,
            showButtonMenu: false,
            editCustomer: false,
            enableEditor: false,
            enableEditPlan: false,
            isRecording: false,
            audioBlob: null,
            audioFile: null,
            type: null,
            mediaRecorder: null,
            user_access: this.$page.props.auth.user.access,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [ 'heading', '|', 'bold', 'italic', 'link', '|', 'undo', 'redo', '|', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'insertTable', 'blockQuote', '|', 'imageUpload', 'mediaEmbed', '|' ],
                table: {
                    toolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
                },
                extraPlugins: [this.uploader],
            },
            form: this.$inertia.form({
                contact_id: this.ticket.contact_id,
                priority_id: this.ticket.priority_id,
                status_id: this.ticket.status_id,
                department_id: this.ticket.department_id,
                category_id: this.ticket.category_id ?? null,
                sub_category_id: this.ticket.sub_category_id,
                assigned_to: this.ticket.assigned_to,
                type_id: this.ticket.type_id,
                subject: this.ticket.subject,
                details: this.ticket.details,
                transcription: this.ticket.transcription,
                action_plan: this.ticket.action_plan,
                files: this.ticket.files,
                comments: this.ticket.comments,
                created_at: this.ticket.created_at,
                removedFiles: [],
                rating: 0,
                review: '',
            }),
        }
    },
    created() {
        console.log(this.ticket.category_id);
        if(this.auth.user.role.slug === 'customer' && this.statuses.length){
            this.type_status = this.statuses.filter(status=> (status.id === this.form.status_id) || status.name.match(/Close.*/))
        }else{
            this.type_status = this.statuses
        }
        this.moment = moment;
    },
    methods: {
        safeHtml,
        getCategories(){
            axios.get(this.route('filter.filter_users_by_department', {department_id: this.form.department_id})).then((res)=>{                
                this.usersExceptCustomers.splice(0, this.usersExceptCustomers.length, ...res.data);
            })
            this.form.category_id = null;
            this.$refs.category.selected = null;
        },
       
        uploader(editor) {
            editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                return new UploadAdapter( loader );
            };
        },
        doFilter(e){
            axios.get(this.route('filter.customers', {search: e.target.value})).then((res)=>{
                this.customers.splice(0, this.customers.length, ...res.data);
            })
        },
        doFilterUsersExceptCustomer(e){
            axios.get(this.route('filter.users_except_customer', {search: e.target.value})).then((res)=>{
                this.usersExceptCustomers.splice(0, this.usersExceptCustomers.length, ...res.data);
            })
        },
        fileError() {
            const key = Object.keys(this.form.errors).find(k => k === 'files' || k.startsWith('files.'));
            return key ? this.form.errors[key] : null;
        },
        fileInputChange(e) {
            let selectedFiles = e.target.files;
            for (let i = 0; i < selectedFiles.length; i++) {
                this.form.files.push(selectedFiles[i]);
            }
        },
        fileRemove(image, index) {
            this.form.files.splice(index, 1);
        },
        fileBrowse() {
            this.$refs.file.click()
        },
        downloadAttachment(file) {
            const link = document.createElement("a");
            link.href = window.location.origin + '/files/' + file.path;
            link.download = file.name;
            link.click();
        },
        removeAttachment(file, index) {
            this.attachments.splice(index, 1);
            this.form.removedFiles.push(file.id)
        },
        getFileSize(size) {
            const i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i]
        },
        uploadFiles() {
            this.form.files = this.$refs.files.files
        },
        update() {
            this.form.post(this.route('tickets.update', this.ticket.id))
            this.form.files = []
            this.form.comment = ''
            this.showMenu = false;
            this.showButtonMenu = false
            this.editCustomer = false
            this.enableEditor = false
            this.enableEditPlan = false
            this.isRecording = false
        },
        destroy() {
            if (confirm('Are you sure you want to delete this ticket?')) {
                this.$inertia.delete(this.route('tickets.destroy', this.ticket.id))
            }
        },
        restore() {
            if (confirm('Are you sure you want to restore this ticket?')) {
                this.$inertia.put(this.route('tickets.restore', this.ticket.id))
            }
        },
        

        // submitComment(type = 'text') {
        //                 const that = this;

        //     // Prepare FormData for multipart/form-data request
        //     const formData = new FormData();
        //     formData.append('comment', this.comment || ''); // Text comment, default to empty string if null
        //     formData.append('user_id', this.user.id);
        //     formData.append('ticket_id', this.ticket.id);
        //     formData.append('_token', this.$page.props.csrf_token);

        //     // Determine the type and audio file
        //     let audioFileName = null;
        //     if (type === 'text') {
        //         formData.append('type', 'text');
        //     } else if (this.audioBlob) {
        //         formData.append('type', 'recorded_audio');
        //         audioFileName = `recording_${Date.now()}.wav`; // Unique filename for WAV
        //         formData.append('audio', this.audioBlob, audioFileName);
        //     } else if (this.audioFile) {
        //         formData.append('type', 'uploaded_audio');
        //         audioFileName = this.audioFile.name; // Use original filename for uploaded files
        //         formData.append('audio', this.audioFile, audioFileName);
        //     } else {
        //         console.error('Invalid type or no audio file provided');
        //         return;
        //     }

        //     console.log('Submitting comment:', { type, audioFileName });

        //     axios.post(this.route('ticket.comment'), formData, {
        //         headers: {
        //             'Content-Type': 'multipart/form-data'
        //         }
        //     }).then((response) => {
        //         if (response.data) {
        //             console.log('Response:', response.data, response.data.type);
        //             const comment = {
        //                 created_at: response.data.created_at,
        //                 details: response.data.details,
        //                 id: response.data.id,
        //                 ticket_id: response.data.ticket_id,
        //                 type: type,
        //                 updated_at: response.data.updated_at,
        //                 user_id: this.user.id,
        //             };
        //             console.log('New comment:', comment);
        //             that.comments.push(comment);
        //         }
        //         this.$emit('comment submitted!');
        //         this.resetForm();
        //     }).catch((error) => {
        //         console.error('Error submitting comment:', error.response ? error.response.data : error.message);
        //     });
        // },

        submitComment(type = 'text') {
            var that = this;
            
            const messageData = {
                comment: this.comment,
                user_id: this.user.id,
                _token: this.$page.props.csrf_token,
                ticket_id: this.ticket.id,
                type: (this.audioBlob || this.audioFile) ? 'uploaded_audio' : 'text',
                audio: this.audioBlob ? [this.audioBlob, 'recording.wav'] : (this.audioFile ? [this.audioFile, 'recording.wav'] : null),
                
            }
            this.type = type;
            console.log(messageData);

            axios.post(this.route('ticket.comment'), messageData, {
                headers: {
                'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if(response.data){
                    console.log(response.data,response.data.type);
                    const comment = {
                        created_at: response.data.created_at,
                        details: response.data.details,
                        id: response.data.id,
                        ticket_id: response.data.ticket_id,
                        type: this.type,
                        updated_at: response.data.updated_at,
                        user_id: this.user.id,
                    }
                    console.log(comment);
                    that.comments.push(comment);
                }
                this.$emit('comment submitted!');
                this.resetForm();
            }).catch((error) => {
                console.log(error);
            });
        },

        resetForm() {
            this.comment = '';
            this.audioBlob = null;
            this.audioFile = null;
        },
        // async startRecording() {
        //     console.log('Starting audio recording...');
        //     try {
        //         console.log('Requesting microphone access...');
        //         const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        //         console.log('Microphone access granted. Stream tracks:', stream.getAudioTracks());

        //         this.mediaRecorder = new MediaRecorder(stream, { mimeType: 'audio/webm' });
        //         console.log('MediaRecorder initialized with mimeType: audio/webm');

        //         const chunks = [];
        //         this.mediaRecorder.ondataavailable = (e) => {
        //             console.log('Data available. Chunk size:', e.data.size, 'bytes');
        //             chunks.push(e.data);
        //         };

        //         this.mediaRecorder.onstop = async () => {
        //             console.log('Recording stopped. Total chunks:', chunks.length);
        //             const blob = new Blob(chunks, { type: 'audio/webm' });
        //             console.log('Created WebM blob. Size:', blob.size, 'bytes', 'Type:', blob.type);

        //             // Convert webm to wav
        //             console.log('Starting WebM to WAV conversion...');
        //             const wavBlob = await this.convertToWav(blob);
        //             console.log('WAV conversion complete. WAV blob size:', wavBlob.size, 'bytes', 'Type:', wavBlob.type);

        //             this.audioBlob = wavBlob;
        //             console.log('Submitting comment with WAV audio...');
        //             this.submitComment('audio');
        //         };

        //         this.mediaRecorder.start();
        //         console.log('Recording started. isRecording:', true);
        //         this.isRecording = true;
        //     } catch (err) {
        //         console.error('Error accessing microphone:', err.message, err);
        //         // Show error message to user
        //     }
        // },

// Convert WebM to WAV
async convertToWav(blob) {
    console.log('Converting blob to WAV. Input blob size:', blob.size, 'Type:', blob.type);
    try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        console.log('AudioContext created. Sample rate:', audioContext.sampleRate);

        const arrayBuffer = await blob.arrayBuffer();
        console.log('Blob converted to ArrayBuffer. Size:', arrayBuffer.byteLength, 'bytes');

        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        console.log('Audio decoded. Channels:', audioBuffer.numberOfChannels, 'Duration:', audioBuffer.duration, 's', 'Sample rate:', audioBuffer.sampleRate);

        // Convert to WAV
        console.log('Converting AudioBuffer to WAV...');
        const wavBuffer = this.audioBufferToWav(audioBuffer);
        console.log('WAV buffer created. Size:', wavBuffer.byteLength, 'bytes');

        const wavBlob = new Blob([wavBuffer], { type: 'audio/wav' });
        console.log('WAV blob created. Size:', wavBlob.size, 'bytes', 'Type:', wavBlob.type);

        return wavBlob;
    } catch (err) {
        console.error('Error converting to WAV:', err.message, err);
        throw err; // Rethrow to allow caller to handle
    }
},

// Helper method to convert AudioBuffer to WAV
audioBufferToWav(buffer) {
    console.log('Building WAV file from AudioBuffer...');
    const numChannels = buffer.numberOfChannels;
    const sampleRate = buffer.sampleRate;
    const format = 1; // PCM
    const bitDepth = 16;

    console.log('WAV parameters:', {
        numChannels,
        sampleRate,
        format: 'PCM',
        bitDepth,
        length: buffer.length
    });

    const result = [];
    const length = buffer.length * numChannels * (bitDepth / 8);
    const dataLength = buffer.length * numChannels * 2;

    // WAV header
    console.log('Writing WAV header...');
    result.push(
        'RIFF',
        this.packNumber(length + 44 - 8, 4), // ChunkSize
        'WAVE',
        'fmt ',
        this.packNumber(16, 4), // Subchunk1Size (16 for PCM)
        this.packNumber(format, 2), // AudioFormat (1 for PCM)
        this.packNumber(numChannels, 2), // NumChannels
        this.packNumber(sampleRate, 4), // SampleRate
        this.packNumber(sampleRate * numChannels * bitDepth / 8, 4), // ByteRate
        this.packNumber(numChannels * bitDepth / 8, 2), // BlockAlign
        this.packNumber(bitDepth, 2), // BitsPerSample
        'data',
        this.packNumber(dataLength, 4) // Subchunk2Size
    );
    console.log('WAV header written. Header size:', result.join('').length, 'bytes');

    // Interleave channels
    console.log('Interleaving audio channels...');
    const channelData = [];
    for (let i = 0; i < numChannels; i++) {
        channelData.push(buffer.getChannelData(i));
        console.log(`Channel ${i} data length:`, channelData[i].length);
    }

    const samples = new Int16Array(buffer.length * numChannels);
    for (let i = 0; i < buffer.length; i++) {
        for (let channel = 0; channel < numChannels; channel++) {
            const sample = channelData[channel][i];
            samples[i * numChannels + channel] = Math.max(-1, Math.min(1, sample)) * 32767;
        }
    }
    console.log('Samples interleaved. Total samples:', samples.length);

    // Write samples
    console.log('Writing audio samples to DataView...');
    const dataView = new DataView(new ArrayBuffer(dataLength));
    for (let i = 0; i < samples.length; i++) {
        dataView.setInt16(i * 2, samples[i], true);
    }
    console.log('Samples written. DataView size:', dataView.byteLength, 'bytes');

    const finalBuffer = new Uint8Array([...result.join('').split('').map(c => c.charCodeAt(0)), ...new Uint8Array(dataView.buffer)]);
    console.log('Final WAV buffer created. Total size:', finalBuffer.byteLength, 'bytes');

    return finalBuffer;
},

// Helper method to pack numbers into binary
packNumber(num, bytes) {
    console.log(`Packing number ${num} into ${bytes} bytes`);
    const result = [];
    for (let i = 0; i < bytes; i++) {
        const byte = (num >> (i * 8)) & 0xFF;
        result.push(byte);
        console.log(`Byte ${i}: ${byte}`);
    }
    const packed = new Uint8Array(result);
    console.log('Packed bytes:', packed);
    return packed;
},

        
        async startRecording() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                this.mediaRecorder = new MediaRecorder(stream);
                const chunks = [];

                this.mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
                this.mediaRecorder.onstop = () => {
                const blob = new Blob(chunks, { type: 'audio/ogg; codecs=opus' });
                this.audioBlob = blob;
                this.submitComment('audio');
                };

                this.mediaRecorder.start();
                this.isRecording = true;
            } catch (err) {
                console.error('Error accessing microphone:', err);
                // You might want to show an error message to the user here
            }
        },
            
        stopRecording() {
            if (this.mediaRecorder && this.isRecording) {
                this.mediaRecorder.stop();
                this.isRecording = false;
            }
        },

        checkComment(type) {
            return this.comments.some(comment => comment.type === type);
        },

        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file && (file.type === 'audio/mpeg' || file.type === 'audio/wav')) {
                this.audioFile = file;
                this.submitComment('audio');
            } else {
                console.error('Please upload an MP3 or WAV file.');
                // You might want to show an error message to the user here
            }
        },
    },
}
</script>
